import { FacetServiceApi } from '../types'
import { buildQueryParamsFacetsObject, buildSelectedFacetsObject } from './facets'

export class ConstructorFacetService implements FacetServiceApi {
  getIsFacetSelected({ selectedFacets, facetName, facetValue, pageParams = {} }) {
    return selectedFacets?.[facetName]?.includes(facetValue)
  }

  handleClickFacet({
    facetName,
    facetValue,
    selectedFacets,
    basicQueryParams,
    updateSelectedFacetsAndQueryParams,
    inputType = 'multiple',
    isQueryParam = false,
  }) {
    const newSelectedFacets = buildSelectedFacetsObject({
      selectedFacets,
      facetName,
      facetValue,
      inputType,
    })

    const newQueryParams = buildQueryParamsFacetsObject({
      basicQueryParams,
      facetName,
      facetValue,
      isQueryParam,
    })
    updateSelectedFacetsAndQueryParams({ newSelectedFacets, newQueryParams, facetName, facetValue })
  }
}
